<script setup lang="ts">
import { useDialogPluginComponent } from 'quasar';
import { useSlots } from 'vue';

defineProps<{
    title?: string;
    message?: string;
    okLabel?: string;
    cancelLabel?: string;
    persistent: boolean;
    cardClasses?: string;
}>();

const slots = useSlots();

defineEmits([
    ...useDialogPluginComponent.emits,
]);

const {
    dialogRef,
    onDialogHide,
    onDialogOK,
    onDialogCancel,
} = useDialogPluginComponent();

defineExpose({
    dialogRef,
    onDialogHide,
    onDialogOK,
    onDialogCancel,
});
</script>

<template>
    <q-dialog
        ref="dialogRef"
        :persistent="persistent"
        @hide="onDialogHide"
    >
        <q-card
            class="q-dialog-plugin"
            :class="cardClasses || ''"
        >
            <q-card-section class="q-dialog__title">
                {{ title }}
            </q-card-section>

            <q-card-section class="q-dialog__message">
                <div>{{ message }}</div>
                <div v-if="slots.content">
                    <slot name="content" />
                </div>
            </q-card-section>

            <slot
                v-if="slots.actions"
                name="actions"
            />

            <q-card-actions
                v-else
                align="right"
            >
                <q-btn
                    class="fsum-button-outlined"
                    :label="cancelLabel || 'Cancel'"
                    no-caps
                    @click="onDialogCancel"
                />
                <q-btn
                    class="fsum-button-dark-blue"
                    :label="okLabel || 'OK'"
                    no-caps
                    @click="onDialogOK"
                />
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>
<style scoped>
.q-dialog__title {
    font-size: 28px;
    font-weight: 500;
    color: var(--fsum-dark-blue);
}
.q-dialog__message {
    font-size: 16px;
}
</style>
